module.exports = __webpack_public_path__ + "img/3.38d8e97f.png";